module.exports = __webpack_public_path__ + "static/media/anubhavray.4e027e40.jpeg";